export function detectDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return "android";
  }

  // Default to browser detection for desktop
  return "desktop";
}

export function detectBrowser() {
  const userAgent = navigator.userAgent.toLowerCase();

  // Note: Chrome on iOS also includes "Safari" in UA
  if (userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1 && userAgent.indexOf("crios") === -1) {
    return "safari";
  }

  // Chrome detection (both desktop and iOS)
  if (userAgent.indexOf("chrome") !== -1 || userAgent.indexOf("crios") !== -1) {
    return "chrome";
  }

  if (userAgent.indexOf("firefox") !== -1) {
    return "firefox";
  }

  if (userAgent.indexOf("edg") !== -1) {
    return "edge";
  }

  if (userAgent.indexOf("trident") !== -1) {
    return "ie";
  }

  return "unknown";
}
